import apiClient from "./axios"

export const getLeads = async (params = {}) => {
  const { data } = await apiClient.get("/leads", { params })
  return data
}

export const getMyLeads = async (params = {}) => {
  const { data } = await apiClient.get("/leads/my", { params })
  return data
}

export const getLeadMeta = async () => {
  const { data } = await apiClient.get("/leads/meta")
  return data
}

export const getLead = async id => {
  const { data } = await apiClient.get(`/leads/${id}`)
  return data
}

export const createLead = async payload => {
  const { data } = await apiClient.post("/leads", payload)
  return data
}

export const updateLead = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/leads/${id}`, payload)
  return data
}

export const updateLeadStatus = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/leads/${id}/status`, payload)
  return data
}

export const assignLead = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/leads/${id}/assign`, payload)
  return data
}

export const addLeadActivity = async ({ id, ...payload }) => {
  const { data } = await apiClient.post(`/leads/${id}/activities`, payload)
  return data
}

export const convertLead = async ({ id, ...payload }) => {
  const { data } = await apiClient.post(`/leads/${id}/convert`, payload)
  return data
}

export const deleteLead = async id => {
  const { data } = await apiClient.delete(`/leads/${id}`)
  return data
}
